var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.833 10.5C16.8439 10.5 14.9362 11.2902 13.5297 12.6967C12.1232 14.1032 11.333 16.0109 11.333 18H8.83301L12.0747 21.2417L12.133 21.3583L15.4997 18H12.9997C12.9997 16.4529 13.6143 14.9692 14.7082 13.8752C15.8022 12.7812 17.2859 12.1667 18.833 12.1667C20.3801 12.1667 21.8638 12.7812 22.9578 13.8752C24.0518 14.9692 24.6663 16.4529 24.6663 18C24.6663 19.5471 24.0518 21.0308 22.9578 22.1248C21.8638 23.2188 20.3801 23.8333 18.833 23.8333C17.2247 23.8333 15.7663 23.175 14.7163 22.1167L13.533 23.3C14.8913 24.6667 16.7497 25.5 18.833 25.5C20.8221 25.5 22.7298 24.7098 24.1363 23.3033C25.5428 21.8968 26.333 19.9891 26.333 18C26.333 16.0109 25.5428 14.1032 24.1363 12.6967C22.7298 11.2902 20.8221 10.5 18.833 10.5Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/RestoreIcon.3e3cd1788fd24b629f4d714ff0956d94.svg";
export { ForwardRef as ReactComponent };